"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatReportFilename = exports.downloadDocument = exports.createDocumentFile = void 0;
var _dateFns = require("date-fns");
var _apex = _interopRequireDefault(require("../apex"));
var _dateHelper = require("./dateHelper");
var _snackbarActions = require("../redux/actions/snackbarActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var b64toBlob = function b64toBlob(b64Data) {
  var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
  var byteCharacters = atob(b64Data);
  var byteArrays = [];
  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  var blob = new Blob(byteArrays, {
    type: contentType
  });
  return blob;
};
var createDocumentFile = exports.createDocumentFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(fileInfo, name) {
    var calls, blobsArray, sliceNum, remainingSlices, saveFile, createAndSaveFile, _createAndSaveFile, i;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _createAndSaveFile = function _createAndSaveFile3() {
            _createAndSaveFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
              var statusCode, reportLocation, response, blob, save, _t;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.p = _context.n) {
                  case 0:
                    statusCode = data.statusCode, reportLocation = data.reportLocation;
                    _context.p = 1;
                    if (!(reportLocation === 'ObjectStorage')) {
                      _context.n = 5;
                      break;
                    }
                    _context.n = 2;
                    return fetch(data.docName);
                  case 2:
                    response = _context.v;
                    if (!response.ok) {
                      _context.n = 4;
                      break;
                    }
                    _context.n = 3;
                    return response.blob();
                  case 3:
                    blob = _context.v;
                    blobsArray.push(blob);
                    _context.n = 5;
                    break;
                  case 4:
                    throw new Error('Something went wrong');
                  case 5:
                    if (statusCode === 'Success' && reportLocation !== 'ObjectStorage') {
                      blobsArray.push(b64toBlob(data.base64Bytes));
                      remainingSlices--;
                    }
                    if (!remainingSlices) {
                      //DEV-6687: remove OR condition blobsArray.length > 0
                      save = saveFile();
                      save(blobsArray, name);
                    }
                    _context.n = 7;
                    break;
                  case 6:
                    _context.p = 6;
                    _t = _context.v;
                    console.error(_t);
                  case 7:
                    return _context.a(2);
                }
              }, _callee, null, [[1, 6]]);
            }));
            return _createAndSaveFile.apply(this, arguments);
          };
          createAndSaveFile = function _createAndSaveFile2(_x3) {
            return _createAndSaveFile.apply(this, arguments);
          };
          saveFile = function _saveFile() {
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            return function (data, fileName) {
              var blob = new Blob(data, {
                type: 'text/csv'
              });
              var url = window.URL.createObjectURL(blob);
              if ((window.navigator.appVersion.toString().indexOf('.NET') > 0 || window.navigator.appVersion.toString().indexOf('Edge') > 0) && window.navigator.msSaveBlob) {
                return window.navigator.msSaveBlob(blob, "".concat(fileName, ".csv"));
              }
              a.href = url;
              a.download = "".concat(fileName, ".csv");
              a.click();
              return window.URL.revokeObjectURL(url);
            };
          };
          calls = fileInfo.numSlices;
          blobsArray = [];
          sliceNum = 0;
          remainingSlices = fileInfo.numSlices;
          if (fileInfo.reportLocation === 'ObjectStorage') {
            createAndSaveFile(fileInfo);
          } else {
            for (i = 0; i < calls; i++) {
              _apex["default"].connection.DownloadDocumentSlice({
                descriptorId: fileInfo.descriptorId,
                sliceNum: sliceNum++
              }).then(function (res) {
                createAndSaveFile(res);
              });
            }
          }
        case 1:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return function createDocumentFile(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var downloadDocument = exports.downloadDocument = function downloadDocument(descriptorId) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'report';
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch) {
      var res, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            _context3.n = 1;
            return _apex["default"].connection.DownloadDocument({
              descriptorId: descriptorId
            });
          case 1:
            res = _context3.v;
            if (res.statusCode === 'Error') {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'DownloadDocumentError',
                text: res.statusMessage,
                type: 'warning'
              }));
            } else {
              createDocumentFile(res, filename);
            }
            _context3.n = 3;
            break;
          case 2:
            _context3.p = 2;
            _t2 = _context3.v;
            dispatch((0, _snackbarActions.showSnack)({
              id: 'DownloadDocumentError',
              text: _t2.o,
              type: 'warning'
            }));
          case 3:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 2]]);
    }));
    return function (_x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var formatReportFilename = exports.formatReportFilename = function formatReportFilename(reportDescriptiveHeader) {
  var reportType = reportDescriptiveHeader.split('|')[0].replace(/([A-Z])/g, ' $1').trim();
  var intervalStartTime = (0, _dateHelper.formatDate)((0, _dateFns.subDays)(reportDescriptiveHeader.split('|')[2], 1), 'MMddyyyy');
  var intervalEndTime = (0, _dateHelper.formatDate)((0, _dateFns.subDays)(reportDescriptiveHeader.split('|')[3], 1), 'MMddyyyy');
  return "".concat(reportType, "_").concat(intervalStartTime, "-").concat(intervalEndTime);
};